import { PageBuilder } from '@/components/PageBuilder'
import { sanityClient } from '@/sanity/lib/client'
import { HOME_PAGE_QUERY, HOMEPAGE_HEADERS_QUERY } from '@/sanity/lib/queries'
import { NextSeo } from 'next-seo';
import { getSiteSettings } from '@/lib/getSiteSettings';

export async function getServerSideProps() {
  const allSlides = await sanityClient.fetch(HOMEPAGE_HEADERS_QUERY);

  // Current time in PST
  const nowPST = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' })
  );

  const heroSlides = allSlides
    .map(slide => {
      const start = slide.useStartDate && slide.startDate
        ? new Date(slide.startDate)
        : new Date(slide._createdAt);

      const end = slide.useEndDate && slide.endDate
        ? new Date(slide.endDate)
        : null;

      const hasStarted = start <= nowPST;
      const notEnded = !end || end >= nowPST;

      if (!hasStarted || !notEnded) return null;

      return {
        ...slide,
        startDate: slide.useStartDate ? slide.startDate : null,
        endDate: slide.useEndDate ? slide.endDate : null,
      };
    })
    .filter(Boolean);

  const siteSettings = await getSiteSettings();
  const page = await sanityClient.fetch(HOME_PAGE_QUERY);

  return {
    props: {
      page,
      heroSlides,
      siteSettings,
    },
  };
}


export default function HomePage({ page, heroSlides }) {
  const {
    content, 
    metaTitle,
    metaDescription,
  } = page || {};

  return page ? (
    <>
      <NextSeo
        title={metaTitle}
        description={metaDescription}
        canonical="https://plpcsanjose.com"
        openGraph={{
          title: metaTitle,
          description: metaDescription,
          url: "https://plpcsanjose.com",
          siteName: "Purple Lotus",
        }}
      />
      <PageBuilder content={content} isHome heroSlides={heroSlides} />
    </>
  ) : (
    "no content"
  );
}